import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import LoanPlan from "./lonaPlan";
import { useQuery } from "react-query";
import { GetAllLoanTemplates } from "../../services/loanTemplate.service";
import { GetAllLoanTemplatesResponse } from "../../models/loanTemplate.model";
import LoanPlanSkeleton from "./LoanPlanSkeleton";
import { LOANPLANTYPEID } from "../../config/cacheKey";

export default function LoanPlans() {
  const [loanPlans, setLoanPlans] = useState<GetAllLoanTemplatesResponse[]>([]);
  const { data, isLoading } = useQuery(
    "loanPlans",
    () => {
      return GetAllLoanTemplates();
    },
    {
      onSuccess: (data) => {
        setLoanPlans(data);
      },
    },
  );
  useEffect(() => {
    localStorage.removeItem(LOANPLANTYPEID);
  }, []);
  if (isLoading) {
    return (
      <div>
        {[...Array(3)].map((_, index) => (
          <LoanPlanSkeleton key={index} />
        ))}
      </div>
    );
  }
  return (
    <Grid container>
      {loanPlans.map((item, index) => (
        <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
          <LoanPlan {...item} />
        </Grid>
      ))}
    </Grid>
  );
}
